import { SearchResponseItem } from './search-response-item.model';

export class StoredResult {
    constructor(public saveDate: Date, public expiryDate: Date, public results: SearchResponseItem[]) { }
}
